import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { AUTH_PATHS } from "../constants";
import { capturePreAuthRedirect } from "../utils";

export const useAuthRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const redirectToAuth = useCallback(
    (extraState: Record<string, unknown> = {}) => {
      const options = capturePreAuthRedirect({ location, extraState });
      navigate(AUTH_PATHS.SIGNIN, options);
    },
    [navigate, location]
  );

  return {
    redirectToAuth,
  };
};
